export default __webpack_public_path__ + "static/media/icon-user-cycle.56a7f6aa.svg";